import { render, staticRenderFns } from "./ModalSuspendedAccount.vue?vue&type=template&id=a7d54306&scoped=true"
import script from "./ModalSuspendedAccount.vue?vue&type=script&lang=js"
export * from "./ModalSuspendedAccount.vue?vue&type=script&lang=js"
import style0 from "./ModalSuspendedAccount.vue?vue&type=style&index=0&id=a7d54306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d54306",
  null
  
)

export default component.exports